module.exports = __webpack_public_path__ + "static/media/phone.850929eb.svg";